import * as AV from "../AVCore/AVCore";
import React, { useState } from "react";
import { Dimensions } from "react-native";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { setSearch } from "../Redux/Actions/userActions";
import _ from "lodash";

const useQuickSearch = () => {
  const dimensions = Dimensions.get("window"); // Dimension of the platform
  const dispatch = useDispatch();

  const [showSearchinput, setshowSearchinput] = useState(false); // Show/Hide input box for mobile
  const [searchType, setSearchType] = useState(""); // Search type
  const [searchInput, setSearchInput] = useState("");
  const [searchAdvInput, setSearchAdvInput] = useState(""); // Advanced Search input value
  const [showSearch, setShowSearch] = useState(false); // Show/Hide Search list
  const [filteredResult, setFilteredResults] = useState<AV.ILink[]>(); // Search result
  const [advFilteredResults, setAdvFilteredResults] = useState<AV.ILink[]>(); // Advanced Search result
  const [showAdvSearch, setShowAdvSearch] = useState(true); // Show/Hide Advanced Search list
  const [isUpdate, setIsUpdate] = useState(false);
  const [resultData, setIsResultData] = useState(false);
  const [toResult, setToResult] = useState(false);
  const [value, setValue] = useState("");

  const localUserSearch = useSelector(
    (state: RootStateOrAny) => state.user.userSearch,
  );
  const user = useSelector((state: RootStateOrAny) => state?.user?.user[0]);

  // Shared filter utility
  const filterResults = (
    results: AV.ILink[],
    {
      excludePet = false,
      searchValue = "",
    }: { excludePet?: boolean; searchValue?: string } = {},
  ) => {
    return _.uniqBy(results, "id").filter(
      (x) =>
        x?.title !== undefined &&
        x?.data !== "Deleted" &&
        x?.data !== "Suspended" &&
        !user?.blocked?.some((y) => y?.id === x?.id) &&
        x?.type !== "Channel" &&
        (!excludePet || x?.type !== "Pet") &&
        (searchValue === "" ||
          x?.title?.toLowerCase().includes(searchValue.toLowerCase()) ||
          x?.data?.toLowerCase().includes(searchValue.toLowerCase())),
    );
  };

  // Local and advanced search
  const searchItems = async (searchValue: string, type: string) => {
    setValue(searchValue);
    setToResult(false);
    setIsResultData(false);
    type === "Advanced"
      ? setSearchAdvInput(searchValue)
      : setSearchInput(searchValue);

    if (searchValue !== "") {
      const searchdata: AV.ILink[] =
        type === "Advanced"
          ? await AV.Person.search(searchValue, "Person")
          : await AV.Person.localSearch(searchValue);

      const locSearch = filterResults(
        [...(localUserSearch ?? []), ...searchdata],
        { searchValue },
      );

      type === "Advanced"
        ? setAdvFilteredResults(locSearch)
        : setFilteredResults(locSearch);
      type === "Advanced" ? setShowAdvSearch(true) : setShowSearch(true);
    } else {
      type === "Advanced" ? setShowAdvSearch(false) : setShowAdvSearch(true);
      type === " " ? setShowSearch(false) : setShowSearch(true);
    }

    if (searchValue?.length === 0) {
      setShowSearch(false);
    }
  };

  // Search Organizations
  const searchTeams = async (searchValue: string) => {
    setSearchInput(searchValue);

    if (searchValue !== "") {
      const searchdata: AV.ILink[] = await AV.AVEntity.search(
        searchValue,
        "Org",
      );
      setFilteredResults(searchdata);
      setShowSearch(true);
    } else {
      setFilteredResults([]);
      setShowSearch(false);
    }

    setIsUpdate(true);
  };

  // Advanced Search
  const advSearch = async (value: string, type: string) => {
    if (!toResult && value?.trim()?.length > 0) {
      setSearchType(type);

      const result: AV.ILink[] = await AV.Person.search(value, type);

      const filtered = filterResults(result, { excludePet: true });
      filtered.length === 0 ? setIsResultData(true) : setIsResultData(false);

      setAdvFilteredResults(filtered);
      setFilteredResults(filtered);

      // Update Redux store
      const locSearch = filterResults([...(localUserSearch ?? []), ...result], {
        excludePet: true,
      });
      dispatch(setSearch(locSearch));
    }
  };

  return {
    dimensions,
    showSearchinput,
    setshowSearchinput,
    searchType,
    searchInput,
    setSearchInput,
    showSearch,
    setShowSearch,
    filteredResult,
    searchItems,
    setIsUpdate,
    showAdvSearch,
    setShowAdvSearch,
    searchAdvInput,
    setSearchAdvInput,
    searchTeams,
    advFilteredResults,
    advSearch,
    setAdvFilteredResults,
    setFilteredResults,
    value,
    setValue,
    resultData,
    setIsResultData,
  };
};

export default useQuickSearch;
